
(function($) {

    /*
     *  Funzioni per PhotoSwiper
     */
    function addImageSizeForPhotoSwiper() {
        var thumbs = $('img[data-big-size]');
        thumbs.each(function(index) {
            if ($(this).parent('a').length > 0) {
                var isImageLink = $(this).parent('a').attr('href').match(/\.(jpeg|jpg|gif|png)$/);
                if (isImageLink) {
                    big_size = $(this).data('big-size');
                    link = $(this).parent('a');
                    link.attr('data-size', big_size);
                    link.wrap('<div class="single-image"></div>');
                }
            }
        });
    }

    function initPhotoSwiper(selector) {
        var galleryItems = $(selector);
        var pswpItems = [];
        galleryItems.each(function(index) {
            var dimensions = $(this).find('a').data('size').split('x');
            var width = parseInt(dimensions[0], 10);
            var height = parseInt(dimensions[1], 10);

            myImage = {
                src: $(this).find('a').attr('href'),
                w: width,
                h: height,
                msrc: $(this).find('img').attr('src')
            };
            pswpItems.push(myImage);
        });


        galleryItems.each(function(index) {
            $(this).click(function(evt) {
                evt.preventDefault();
                openPhotoSwipe(pswpItems, index);
            });
        });
    }

    function openPhotoSwipe(galleryItems, index) {
        var options = {
            index: index
        };
        var pswpElement = $('.pswp')[0];

        var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, galleryItems, options);
        gallery.init();
    }

    function scrollAnimations(desktopScrollTop) {
			var header = $('#js-header'),
				menu = $('#js-fixed-menu'),
				scrollBooking = $('.bookingHorizontal'),
				bookingH = scrollBooking.outerHeight(),
				BookingPlaceholder = $('#js-bookingPlaceholder'),
				headerPlaceholder = $('#js-headerPlaceHolder'),
				headerH = $('#js-header').outerHeight(), // Height compreso di margini e bordi
				menuH = $('#js-fixed-menu').innerHeight(),
				slideshowH = $('.header-slideshow').outerHeight();

				if ( slideshowH != null )
					var scrollValueDesktop = headerH + $('.header-slideshow').outerHeight() - headerH;
				else
					var scrollValueDesktop = headerH + 50;

			if ($('body').is('.is-mobile, .is-tablet')) {
				var scrollValue = headerH - menuH;
			}

			$(window).scroll(function() {
				scrolltop = $(window).scrollTop();

				if ($('body').is('.is-mobile, .is-tablet')) {
						if (scrolltop >= scrollValue) {
								menu.addClass("scroll");
						} else {
								menu.removeClass("scroll");
						}
				} else {
					if (scrolltop >= scrollValueDesktop) {
						header.addClass("scroll");
						BookingPlaceholder.css( 'height', scrollBooking.outerHeight() );
						scrollBooking.addClass('show');
					} else {
						header.removeClass("scroll");
						BookingPlaceholder.css( 'height', "" );
						scrollBooking.removeClass("show");
					}
				}
			});
		}

    function galleryRoom(galleryRoom1, galleryRoom2) {

        var sync1 = $(galleryRoom1);
        var sync2 = $(galleryRoom2);
        
        sync1.owlCarousel({
            singleItem : true,
            slideSpeed : 1000,
            navigation: false,
            pagination:false,
            afterAction : syncPosition,
            responsiveRefreshRate : 200,
        });
        
        sync2.owlCarousel({
            items : 6,
            itemsDesktop      : [1199,6],
            itemsDesktopSmall : [979,6],
            itemsTablet       : [768,4],
            itemsMobile       : [479,3], 
            pagination : false,
            responsiveRefreshRate : 100,
            afterInit : function(el){
                el.find(".owl-item").eq(0).addClass("synced");
            }
        });
        
        function syncPosition(el){
            var current = this.currentItem;
            $(galleryRoom2)
            .find(".owl-item")
            .removeClass("synced")
            .eq(current)
            .addClass("synced")
            if($(galleryRoom2).data("owlCarousel") !== undefined){
                center(current)
            }
        }
        
        $(galleryRoom2).on("click", ".owl-item", function(e){
            e.preventDefault();
            var number = $(this).data("owlItem");
            sync1.trigger("owl.goTo",number);
        });
        
        function center(number){
            var sync2visible = sync2.data("owlCarousel").owl.visibleItems;
            var num = number;
            var found = false;
            for(var i in sync2visible){
            if(num === sync2visible[i]){
                var found = true;
            }
            }
        
            if(found===false){
            if(num>sync2visible[sync2visible.length-1]){
                sync2.trigger("owl.goTo", num - sync2visible.length+2)
            }else{
                if(num - 1 === -1){
                num = 0;
                }
                sync2.trigger("owl.goTo", num);
            }
            } else if(num === sync2visible[sync2visible.length-1]){
            sync2.trigger("owl.goTo", sync2visible[1])
            } else if(num === sync2visible[0]){
            sync2.trigger("owl.goTo", num-1)
            }
        }
        
    }



    function $j(argument) {
        var result = jQuery(argument);
        if (result.length === 0) return null;
        else return result;
    } 

    $j(document).ready(function() {

        initPhotoSwiper(".gallery .gallery-item");
        galleryRoom("#sync1", "#sync2");

				$('.review p').collapser({
            mode: 'words',
            truncate: 30,
            showText: '+',
            hideText: '-',
            controlBtn: 'btnMore',
        });

				$('#children').change(function() {
					if ( $( window ).width() > 991 ) {
						//$('.js-equalHeight-form-group').equalHeights();
						var h = $('.form-section-4').height();
						//alert('h: '+h);
						if ($('#children').val() > 2) h += 120;
						else if ($('#children').val() > 0) h += 60;
						$('.form-section-1').height(h);
						$('.form-section-2').height(h);
						$('.form-section-3').height(h);
					}
				});

    });

    /*
     *	Funzione per l'inizializzazione della mappa
     */
    function initializeGmap() {
        $('*[data-location]').each(function() {
            var map = $(this),
                address = map.attr('data-location');
            map.setGMap({
                address: address
            });
        });
    }

    $j(window).load(function() {

			scrollAnimations(300);
			/*
			 *	Attraverso il Google Loader carico il modulo mappa
			 */
			$.getScript('https://www.google.com/jsapi', function() {
					google.load('maps', '3', {
							other_params: 'sensor=true&language='+lang+'&key='+google_api_key, // chiave per hotel qui + var lingua
							callback: function() {
									initializeGmap();
							}
					});
			});

			if ( $( window ).width() > 991 ) {
				$('.js-equalHeight-footer').equalHeights();
				$('.js-equalHeight-offerte-descr').equalHeights();
				$('.js-equalHeight-offerte-price').equalHeights();
				$('.js-equalHeight-offerte-title').equalHeights();
				$('.js-equalHeight-servizi').equalHeights();
				$('.js-equalHeight-buoni-motivi-box').equalHeights();
				$('.js-equalHeight-item').equalHeights();
				$('.js-equalHeight-room-descr').equalHeights();
				$('.js-equalHeight-form-group').equalHeights();
				$('.js-equalHeight-news-descr').equalHeights();
				$('.js-equalHeight-room-title').equalHeights();
				$('.js-equalHeight-video-box').equalHeights();
			}
			/*if ( $( window ).width() > 767 ) {
					$('.js-offerte').equalHeights();
			}*/
/*
			$('.owl-carousel3').owlCarousel({
				loop:true,
				margin:10,
				responsiveClass:true,
				responsive:{
						0:{
								items:1,
								nav:true
						},
						600:{
								items:2,
								nav:false
						},
						1000:{
								items:3,
								nav:true,
								loop:false
						}
				}
			});
*/
    }); 

    $j(window).resize(function() {

			if ( $( window ).width() > 991 ) {
				$('.js-equalHeight-footer').equalHeights();
				$('.js-equalHeight-offerte-descr').equalHeights();
				$('.js-equalHeight-offerte-price').equalHeights();
				$('.js-equalHeight-offerte-title').equalHeights();
				$('.js-equalHeight-servizi').equalHeights();
				$('.js-equalHeight-buoni-motivi-box').equalHeights();
				$('.js-equalHeight-item').equalHeights();
				$('.js-equalHeight-room-descr').equalHeights();
				$('.js-equalHeight-form-group').equalHeights();
				$('.js-equalHeight-news-descr').equalHeights();
				$('.js-equalHeight-room-title').equalHeights();
				$('.js-equalHeight-video-box').equalHeights();
			}
		});

})(jQuery);
